const TabsControls = (($) => {
    class Tabs {
        constructor(node) {
            this.node = node;
            this.$node = $(this.node);
            this.$tabs = this.$node.find('[role="tab"]');
            this.$panels = this.$node.find('[role="tabpanel"]');
        }

        init() {
            this.bindEvents();
        }

        bindEvents() {
            this.$tabs.on('click', (event) => this.changeTab(event));
            this.$tabs.on('keydown', (event) => this.navigateTabs(event));
        }

        changeTab(event) {
            const $selectedTab = $(event.target);
            const selectedPanelId = $selectedTab.attr('aria-controls');
            const $selectedPanel = this.$node.find(`#${selectedPanelId}`);

            this.$tabs.attr('aria-selected', 'false');
            this.$panels.attr('aria-hidden', 'true');

            $selectedTab.attr('aria-selected', 'true').attr('tabindex', '0');
            $selectedPanel.attr('aria-hidden', 'false');
        }

        navigateTabs(event) {
            const key = event.key;
            let $currentTab = $(event.target);
            let $newTab;

            if (key === 'ArrowRight' || key === 'ArrowDown') {
                $newTab = $currentTab.next('[role="tab"]');
                if (!$newTab.length) {
                    $newTab = this.$tabs.first();
                }
            } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
                $newTab = $currentTab.prev('[role="tab"]');
                if (!$newTab.length) {
                    $newTab = this.$tabs.last();
                }
            }

            if ($newTab.length) {
                $newTab.focus();
                this.changeTab({target: $newTab});
            }
        }
    }

    return {
        init({ selector } = {}) {
            $(selector).each((index, parent) => {
                const module = new Tabs(parent);
                module.init();
            });
        },
    };
})(window.jQuery);

// DOM Ready
(($) => {
    $(document).ready(() => {
        TabsControls.init({
            selector: '[role="tablist"]',
        });
    });
})(window.jQuery);
